<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <el-select
          v-model="value"
          class="control__select"
          :disabled="!selectStatus"
          placeholder="false"
          @change="changeOption"
        >
          <el-option
            v-for="(select, index) in selectOption"
            :key="index"
            :label="select.label"
            :value="select.value"
          />
        </el-select>
        <el-input
          v-if="value === 'number' && selectStatus === true"
          v-model="num"
          :min="min"
          :max="max"
          type="number"
          class="control__aditional"
          :disabled="!selectStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    numDefault: {
      type: Number,
      default: 0
    },
    hint: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean
    }
  },
  data () {
    return {
      value: this.default,
      num: this.numDefault,
      selectStatus: this.status,
      selectOption: this.options,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptions'])
  },
  watch: {
    clearOptions (val) {
      if (val) {
        this.selectStatus = false
      }
    },
    eventClick (val) {
      this.value = this.default
      this.num = this.numDefault
      this.selectStatus = val
    },
    selectStatus (val) {
      if (val == true) {
        this.changeOption()
      }
    }
  },
  methods: {
    changeOption () {
      const value = this.selectStatus === true && this.value !== 'number'
        ? `${this.value}` : this.selectStatus === true && this.value === 'number' &&
        this.num > 0 ? `${this.num}` : ''

      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>
